// @ts-nocheck
import { Identity } from "@pdfking/tfunc"
import { scan } from "./scan"

/**
 * Removes duplicates from iterable.
 *
 * Uses key function to determine uniqueness. Keeps last occurrence.
 *
 * @param iterable - Array, object, or primitive
 * @param f - Key function (default: Identity)
 * @returns Array with duplicates removed
 *
 * @example
 * ```ts
 * import { delete_duplicates } from "@pdfking/rfunc"
 *
 * delete_duplicates([1, 2, 1, 3]) // [2, 1, 3]
 * delete_duplicates([{ a: 1 }, { a: 1 }, { a: 2 }], v => v.a) // [{ a: 1 }, { a: 2 }]
 * ```
 */
export const delete_duplicates = (iterable, f: any = Identity) => {
  const map = new Map()

  scan(item => map.set(f(item), item), iterable)

  return [...map.values()]
}
